import React, { useContext, useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { Alert } from '@mantine/core';
import { InfoCircle } from 'tabler-icons-react';
import { Context as RegistrationContext } from '../../../providers/RegistrationProvider';
import { triggerNotification } from '../../../helpers/notificationHelper';
import ResponsiveModal from '../../common/ResponsiveModal';
import AppStack from '../../common/AppStack';
import AppText from '../../common/AppText';

const UpdatePaymentMethodModal = ({
  isOpen,
  onClose,
  pkRegCart,
  pkRegCartPayment
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { createCartChangePaymentMethodSession } = useContext(
    RegistrationContext
  );

  useEffect(() => {
    if (isOpen) {
      setIsLoading(false);
    }
  }, [isOpen]);

  return (
    <ResponsiveModal
      formSectionProps={{
        onCancel: onClose,
        onSubmit: () => {
          setIsLoading(true);
          createCartChangePaymentMethodSession(
            pkRegCart,
            pkRegCartPayment,
            (data) => {
              if (data?.sessionUrl) {
                window.location.href = data.sessionUrl;
              }
              else {
                triggerNotification();
                setIsLoading(false);
              }
            },
            (error) => {
              triggerNotification(error);
              setIsLoading(false);
            }
          );
        },
        isLoading,
        submitTitle: 'Continue'
      }}
      isNewModalStyle
      isOpen={isOpen}
      onClose={onClose}
      title="Update card details"
    >
      <AppStack style={{ gap: 20 }}>
        <AppStack style={{ gap: 10 }}>
          <AppText style={{ fontSize: 16 }}>
            You&apos;ll be taken to a secure payment page to enter your new card
            details.
          </AppText>
          <AppText style={{ fontSize: 14, color: '#666' }}>
            The new card replaces the card currently on file for this payment
            plan, and will be used for the remaining scheduled payments.
          </AppText>
        </AppStack>

        <Alert
          color="blue"
          icon={<InfoCircle style={{ width: 25, height: 25 }} />}
          variant="outline"
        >
          <AppText style={{ fontSize: 14 }} weight={500}>
            No charge is made now.
          </AppText>
        </Alert>
      </AppStack>
    </ResponsiveModal>
  );
};

UpdatePaymentMethodModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  pkRegCart: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  pkRegCartPayment: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default UpdatePaymentMethodModal;
